
import { NotifyHelper } from "../../../helpers/toast";
import { eKeHoachMonFullPageActionsObj } from "../../action-types/ke-hoach/IKeHoachMonFullPageActions";

import { generateActionForKey, generateActions } from "../generateActions";

export const keHoachMonFullPageActions = {
  ...generateActions(eKeHoachMonFullPageActionsObj, "KE_HOACH_MON_FULL_PAGE"),
  ...generateActionForKey(eKeHoachMonFullPageActionsObj, "KE_HOACH_MON_FULL_PAGE", "ADDING_MONHOC_SUCCESS", () => {
    NotifyHelper.Success("Saved")
  }),
  ...generateActionForKey(eKeHoachMonFullPageActionsObj, "KE_HOACH_MON_FULL_PAGE", "UPDATE_SUCCESS", () => {
    NotifyHelper.Success("Saved")
  }),
  ...generateActionForKey(eKeHoachMonFullPageActionsObj, "KE_HOACH_MON_FULL_PAGE", "PASTE_CLIPBOARD_DATA_SUCCESS", () => {
    NotifyHelper.Success("Sao chép thành công")
  }),
  ...generateActionForKey(eKeHoachMonFullPageActionsObj, "KE_HOACH_MON_FULL_PAGE", "PASTE_CLIPBOARD_DATA_ERROR", () => {
    NotifyHelper.Error("Sao chép thất bại")
  }),
  ...generateActionForKey(eKeHoachMonFullPageActionsObj, "KE_HOACH_MON_FULL_PAGE", "TACH_KHOI_GIANG_SUCCESS", () => {
    NotifyHelper.Success("Tách khối giảng thành công")
  }),
  ...generateActionForKey(eKeHoachMonFullPageActionsObj, "KE_HOACH_MON_FULL_PAGE", "TACH_KHOI_GIANG_ERROR", () => {
    NotifyHelper.Error("Tách khối giảng thất bại")
  }),
   ...generateActionForKey(eKeHoachMonFullPageActionsObj, "KE_HOACH_MON_FULL_PAGE", "UPDATE_ERROR", () => {
    NotifyHelper.Error("Cập nhật thất bại")
  }),
};
